import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Phone } from 'lucide-react';
import './Navbar.css';

const SERVICE_LINKS = [
  { to: '/webbdesign', label: 'Webbdesign' },
  { to: '/e-handel', label: 'E-handel' },
  { to: '/skraddarsydda-system', label: 'Skräddarsydda system' },
  { to: '/seo', label: 'SEO' },
  { to: '/hemsida-falun', label: 'Hemsida i Falun' },
  { to: '/priskalkylator', label: 'Priskalkylator' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setServicesOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isOpen ? 'menu-open' : ''}`}>
      <div className="container nav-content">
        <Link to="/" className="logo" onClick={closeMenu}>Briljans</Link>

        <div className="nav-actions">
          <Link to="/#contact" className="btn-primary nav-cta-mobile" onClick={closeMenu}>Kontakta oss</Link>
          <a href="tel:0766140446" className="nav-call" aria-label="Ring oss">
            <Phone size={18} />
          </a>
          <button
            type="button"
            className="menu-icon"
            aria-label="Meny"
            aria-expanded={isOpen}
            aria-controls="nav-menu"
            onClick={toggleMenu}
          >
            <span className={isOpen ? 'bar open' : 'bar'}></span>
            <span className={isOpen ? 'bar open' : 'bar'}></span>
            <span className={isOpen ? 'bar open' : 'bar'}></span>
          </button>
        </div>

        <ul id="nav-menu" className={`nav-links ${isOpen ? 'active' : ''}`}>
          <li><Link to="/#portfolio" className="nav-link" onClick={closeMenu}>Projekt</Link></li>
          <li className={`nav-dropdown ${servicesOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="nav-link nav-dropdown-trigger"
              aria-expanded={servicesOpen}
              onClick={() => setServicesOpen(!servicesOpen)}
            >
              Tjänster <ChevronDown size={15} className="nav-dropdown-chevron" />
            </button>
            <ul className="nav-dropdown-menu">
              {SERVICE_LINKS.map((s) => (
                <li key={s.to}>
                  <Link to={s.to} onClick={closeMenu}>{s.label}</Link>
                </li>
              ))}
              <li className="nav-dropdown-all">
                <Link to="/#services" onClick={closeMenu}>Alla tjänster →</Link>
              </li>
            </ul>
          </li>
          <li><Link to="/#prices" className="nav-link" onClick={closeMenu}>Priser</Link></li>
          <li className="nav-item-calc"><Link to="/priskalkylator" className="nav-link" onClick={closeMenu}>Räkna ut pris</Link></li>
          <li><Link to="/blogg" className="nav-link" onClick={closeMenu}>Blogg</Link></li>
          <li><Link to="/#about" className="nav-link" onClick={closeMenu}>Om oss</Link></li>
          <li><Link to="/portal/logga-in" className="nav-link nav-login" onClick={closeMenu}>Logga in</Link></li>
          <li className="nav-item-phone">
            <a href="tel:0766140446" className="nav-link nav-phone" aria-label="Ring oss på 076-614 04 46" onClick={closeMenu}>
              <Phone size={16} />
              <span className="nav-phone-number">076-614 04 46</span>
            </a>
          </li>
          <li className="nav-item-cta"><Link to="/#contact" className="btn-primary" onClick={closeMenu}>Kontakta oss</Link></li>
        </ul>
      </div>
    </nav>
  );
}
